import { Theme, useMediaQuery } from '@mui/material';
import { useEffect } from 'react';

import config from '@/config';
import { AppRouteWrapper } from '@/containers';
import { usePersistUtmParameters, useUrlRegion } from '@/hooks';
import { initLogRocket, initSentry } from '@/services';

export const AnonymousSessionLoader = () => {
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('sm'),
  );

  useEffect(() => {
    window.Intercom('boot', {
      user_id: undefined,
      app_id: config.INTERCOM_APP_ID,
      vertical_padding: 100,
      hide_default_launcher: isMobile,
    });
  }, [isMobile]);

  useEffect(() => {
    initSentry({});
    initLogRocket({});
  }, []);

  usePersistUtmParameters();
  useUrlRegion();

  return <AppRouteWrapper />;
};
